import { Flex, Text, Title } from "@mantine/core";
import {
  CivilSectorExperienceSvg,
  DiverseIndustryExposureSvg,
  EmailManagerSvg,
  ShortTermEntrepreneurshipSvg,
  SpecialistToManagerSvg,
} from "../../../shared/svg";
import { PDFPage } from "./PDFPage";
import "../Report.scss";
import useReportStore from "../../../store/useReportStore";

interface CareerMilestone {
  title: string;
  description: string;
  reasoning: string;
}

interface CareerMilestonesArr {
  title: string;
  description: string;
  milestones: CareerMilestone[];
}

export const CareerMilestonesPDF = () => {
  const { report } = useReportStore();

  function transformToCareerMilestones(
    rawData: CareerMilestone[]
  ): CareerMilestonesArr {
    return {
      title: report.milestones?.mark_down
        ? report.milestones?.mark_down?.replace(/^## /, "")
        : "",
      description: report.milestones?.explanation
        ? report.milestones?.explanation
        : "",
      milestones: rawData,
    };
  }

  // Отримуємо дані з бекенду
  const milestonesData = report?.milestones || [];
  const content = transformToCareerMilestones(milestonesData.data);

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {content.title}
      </Title>

      <Text mb={80} size="28px" lh="42px" c="dimmed">
        {content.description}
      </Text>

      <Flex justify="space-between" align="center" ta="center" className="test">
        {content.milestones.slice(0, 3).map((milestone, index) => (
          <Text key={index} fw="bold" size="22px" maw={201}>
            {milestone.title}
          </Text>
        ))}
      </Flex>

      <Flex
        my={39}
        justify="space-between"
        pos="relative"
        className="career-milestones"
      >
        <div className="timeline" />
        <EmailManagerSvg />
        <SpecialistToManagerSvg />
        <CivilSectorExperienceSvg />
        <ShortTermEntrepreneurshipSvg />
        <DiverseIndustryExposureSvg />
      </Flex>

      <Flex justify="space-around" align="center" ta="center">
        {content.milestones.slice(3).map((milestone, index) => (
          <Text key={index} fw="bold" size="22px" maw={201}>
            {milestone.title}
          </Text>
        ))}
      </Flex>

      {content.milestones.map((milestone, index) => (
        <Text key={index} mt={38} size="24px">
          <b>{milestone.title}</b>: {milestone.description}
        </Text>
      ))}
    </PDFPage>
  );
};
